import { Collapse } from 'antd';
import '../scss/layout.scss';

export const Collapsible = ({tab, onChange, activeKey}) =>{

    const items0 = [
        {
          key: '1',
          label: 'Efficient Workflow',
          children: 
          <div className='collapse-content'>
            <p className='head'>Experience a finely tuned system that streamlines operations and boosts productivity.</p>
            <p  className='desc'>Our solutions can help businesses enhance logistics process efficiency by up to 15% and administrative processes by up to 50%, ensuring your team spends less time on logistics and more on strategic initiatives.</p>
          </div>,
        },
        {
          key: '2',
          label: 'No More Paperwork',
          children: 
          <div className='collapse-content'>
            <p className='head'>Eliminate the burden of excessive paperwork.</p>
            <p  className='desc'>Our modern and holistic approach can greatly reduce administrative tasks, allowing you to reallocate resources towards driving growth and strengthening team connections.</p>
          </div>,
        },
        {
          key: '3',
          label: 'Integrate Seamlessly',
          children: 
          <div className='collapse-content'>
            <p className='head'>Connect your systems effortlessly through innovative integrations.</p>
            <p  className='desc'>Our approach promotes real-time data flow and collaboration, minimizing operational silos to ensure all your tools work in unison for smarter, more cohesive decision-making.</p>
          </div>,
        },
      ];
      const items1 = [
        {
          key: '1',
          label: 'Optimize Revenue Streams',
          children: 
          <div className='collapse-content'>
            <p className='head'>Unlock new revenue opportunities.</p>
            <p  className='desc'>Leverage actionable insights to refine your business model—our approach can boost revenue potential by up to 25%, opening pathways to untapped market segments.</p>
          </div>,
        },
        {
          key: '2',
          label: 'Reduce Operational Costs',
          children: 
          <div className='collapse-content'>
            <p className='head'>Cut expenses and free up capital.</p>
            <p  className='desc'>Streamline processes with automated systems that may reduce operational costs by around 20%, enabling you to reinvest in growth initiatives.</p>
          </div>,
        },
        {
          key: '3',
          label: 'Leverage Data-Driven Decisions to Maximize Profit',
          children: 
          <div className='collapse-content'>
            <p className='head'>Make informed, profit-focused decisions.</p>
            <p  className='desc'>With our platform's insights, you can dynamically adjust strategies to optimize performance and enhance overall profitability.</p>
          </div>,
        },
      ];
      const items2 = [
        {
          key: '1',
          label: 'Real-Time Analytics',
          children: 
          <div className='collapse-content'>
            <p className='head'>Stay ahead with up-to-the-minute data.</p>
            <p  className='desc'>Readily capture data that can illuminate trends and shifts in your market. Our platform empowers you to monitor performance in real time, ensuring every decision is timely and well-informed.</p>
          </div>,
        },
        {
          key: '2',
          label: 'Actionable Insights',
          children: 
          <div className='collapse-content'>
            <p className='head'>Transform data into strategic actions.</p>
            <p  className='desc'>Convert complex data into clear, actionable recommendations. With our system, you can confidently navigate challenges and capitalize on opportunities, making decisions that drive sustainable growth.</p>
          </div>,
        },
      ];
      const items3 = [
        {
          key: '1',
          label: 'Seamless Growth',
          children: 
          <div className='collapse-content'>
            <p className='head'>Scale effortlessly as your business evolves.</p>
            <p  className='desc'>Our platform can adapt to your changing needs, ensuring your infrastructure grows with your business while handling increased workloads effortlessly.</p>
          </div>,
        },
        {
          key: '2',
          label: 'Modular Flexibility',
          children: 
          <div className='collapse-content'>
            <p className='head'>Integrate new features on demand.</p>
            <p  className='desc'>Benefit from a modular system that may allow you to add functionalities as needed, keeping your operations agile and responsive.</p>
          </div>,
        },
        {
          key: '3',
          label: 'Future-Proof Reliability',
          children: 
          <div className='collapse-content'>
            <p className='head'>Build a robust foundation for sustainable expansion.</p>
            <p  className='desc'>Designed for long-term success, our solutions can maintain consistent performance as your business scales, ensuring a robust and tailored foundation for future growth.</p>
          </div>,
        },
      ];

    return(
        <Collapse 
          items={tab===0?items0:tab===1?items1:tab===2?items2:items3} 
          activeKey={activeKey} 
          defaultActiveKey={['1']} 
          className='collapse' 
          onChange={onChange} 
          accordion
        />
    )
}